import { RunConfigService, ConfigService } from '@nuskin/ns-util'
import { UserService } from '@nuskin/ns-account'
import axios from 'axios'

const toSafeFloat = (str, fallback) => {
    const value = parseFloat(str)
    return isFinite(value) ? value : fallback
}

export async function getAvailableCampaigns(options = {}) {
    const runCfg = RunConfigService.getRunConfig()
    const mktCfg = ConfigService.getMarketConfig()
    const user = UserService.getUser()

    // Campaigns do not apply to anonymous users
    if (!user) return []

    const salesChannel = options.salesChannel || 'WEB'
    const country = options.country || runCfg.country
    const baseUrl = mktCfg.checkout.availableCampaignsForCustomerUrl

    if (!baseUrl) throw new Error('Available Campaigns URL not defined in market configuration')

    const url = `${baseUrl}/${user.id}?country=${country}&salesChannel=${salesChannel}`

    const { data } = await axios.get(url, {
        validateStatus: (code) => code < 600,
        headers: {
            client_id: mktCfg.checkout.clientId,
            client_secret: mktCfg.checkout.clientSecret,
            Authorization: `JWT ${user.eid}`
        }
    })

    return data.CampaignItemList || []
}

export async function getAllCouponOffers(options = {}) {
    const runCfg = RunConfigService.getRunConfig()
    const mktCfg = ConfigService.getMarketConfig()

    const country = options.country || runCfg.country
    const lang = options.language || runCfg.language
    const baseUrl = mktCfg.checkout.availableCouponsForLocaleUrl

    if (!baseUrl) throw new Error('Available Coupons URL not defined in market configuration')

    const url = `${baseUrl}/${lang}_${country}.service.json`

    const { status, data } = await axios.get(url, {
        validateStatus: (code) => code < 400 || code === 404 // allow 404 response to resolve
    })

    // If no coupons found for this market/language, return empty list
    if (status === 404) return []

    // If response structure is not array-like, return empty list
    if (!Array.isArray(data)) return []

    /** @type {CouponOfferAemObject[]} */
    const couponObjects = data

    return couponObjects
        .filter((obj) => obj.campaignId) // Remove any response elements that aren't coupon offers
        .map((obj) => ({
            campaignId: obj.campaignId,
            code: obj.code,
            desc: obj.desc,
            webDesc: obj.webDesc,
            minimumPurchasePrice: toSafeFloat(obj.minimumPurchasePrice, 0),
            minimumPV: toSafeFloat(obj.minimumPV, 0),
            expiration: obj.expiration ? new Date(obj.expiration) : undefined,
            imageUrl: obj.imageUrl,
            discountAmount: toSafeFloat(obj.discountAmount, 0),
            orderTypeAvailability: obj.orderTypeAvailability || 'both'
        }))
}

export async function getAvailableCouponOffers(options = {}) {
    const [campaigns, coupons] = await Promise.all([getAvailableCampaigns(options), getAllCouponOffers(options)])

    const campIds = campaigns.map(camp => camp.campaignId)

    return coupons.filter(coup => campIds.includes(coup.campaignId))
}

export default {
    getAvailableCampaigns,
    getAllCouponOffers,
    getAvailableCouponOffers
}
